import Api from '@/services/Api'

export default {
    getCausacionByFecha(fecha){
        return Api().get('contratoCausacion/getCausacionByFecha/'+fecha)
    },
    createCausacion(datos){
        return Api().post('contratoCausacion/create',datos)
    }
}